import React from "react";
import { useEffect } from "react";
import Navbarlogedin from "./Navbarlogedin";
import "./UpcomingInterviews.css";
import DatePicker from "react-date-picker";
import UpcomingInterview from "./cards/UpcomingInterview";
import axios from "axios";
import { Helmet } from "react-helmet";

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a p");
  links.forEach((link) => {
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === "Upcoming Interviews") {
      link.classList.add("active");
    }
  });
};

const UpcomingInterviews = () => {
  useEffect(() => {
    changeLink();
  }, []);
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    console.log(currentScrollPos);
    if (currentScrollPos >= 104) {
      document.querySelector(".interview-head").style.position = "sticky";
      document.querySelector(".interview-head").style.top = "0";
    } else {
      document.querySelector(".interview-head").style.position = "unset";
      document.querySelector(".interview-head").style.top = "0";
    }
    prevScrollpos = currentScrollPos;
  };
  const [count, setCount] = React.useState(-2);
  const [cards, setCards] = React.useState();
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);
  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    async function fetchData() {
      const req = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/get`);
      setCards(req.data);
      for (let i = 0; i < req.data.length; i++) {
        if (req.data[i].payment === true) {
          console.log("fasa");
          console.log(count);
        }
      }
    }

    fetchData();
  }, []);
  return (
    <>
      <Helmet>
        <title>Interwiu | Upcoming</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <div className="upcoming-interview interviews">
        {/* <div className="interviews-container"></div> */}
        <div
          className="flex justify-center items-center my-4 mx-3 w-auto"
          id="head"
        >
          <h2 className="interview-head text-2xl font-medium">
            Upcoming Interviews {count ? count : 0}
          </h2>
        </div>
        <div className="interview-cont">
          <div className="flex justify-between mx-8">
            <div>
              Showing the results for {date ? date.toDateString() : "all days"}
            </div>
            <div className="flex gap-2">
              <label htmlFor="date">Filter by Date: </label>
              <DatePicker
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                value={date}
              />
            </div>
          </div>
          <div className="interviews-list">
            <UpcomingInterview
              user="{user}"
              name="John Doe"
              desg="ML Engineer, Walmart, USA"
              price="299"
              profile="Data Science"
              slot="12:00 PM - 12:30 PM"
              id="#y8as7f"
              status={"true"}
              payment={true}
              update=""
              logo={require("../../images/amazon.png")}
            />
            <UpcomingInterview
              user="{user}"
              name="John Doe"
              desg="ML Engineer, Walmart, USA"
              price="299"
              profile="Data Science"
              slot="12:00 PM - 12:30 PM"
              id="#y8as7f"
              status={"true"}
              payment={true}
              update=""
              logo={require("../../images/amazon.png")}
            />
            <UpcomingInterview
              user="{user}"
              name="John Doe"
              desg="ML Engineer, Walmart, USA"
              price="299"
              profile="Data Science"
              slot="12:00 PM - 12:30 PM"
              id="#y8as7f"
              status={"true"}
              payment={true}
              update=""
              logo={require("../../images/amazon.png")}
            />
            {cards?.map((result) => (
              <>
                <UpcomingInterview
                  name={result.toname}
                  //desg={result.desg}
                  profile={result.profile}
                  price={result.price}
                  slot={result.slot}
                  status={result.status}
                  id={result._id}
                  payment={result.payment}
                  update="active"
                  logo={require("../../images/amazon.png")}
                />
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingInterviews;
